// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__27VK2","bookingInfo":"TimeRange_bookingInfo__3nsas","dateSection":"TimeRange_dateSection__asxv2"};